import { render, staticRenderFns } from "./UpdateZone.vue?vue&type=template&id=1f59711e"
import script from "./UpdateZone.vue?vue&type=script&lang=js"
export * from "./UpdateZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports